import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchCustomerDiagnoseCasesCount = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/customer-diagnose-case/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchCustomerDiagnoseCases = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/customer-diagnose-case/list", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'warning'
                }
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const fetchCustomerDiagnoseCase = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/customer-diagnose-case/load", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose case."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose case."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const updateCustomerDiagnoseCase = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/customer-diagnose-case/update", filterData);
            if (countRes.data && countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated diagnose case.`,
                    options: {
                        variant: 'success'
                    }
                });
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot update diagnose case."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update diagnose case."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const updateCustomerDiagnoseCaseParams = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/customer-diagnose-case/update-case-params', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated diagnose case params.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit diagnose case params."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const resetDiagnoseCaseParams = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/customer-diagnose-case/reset-case-params', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully reset diagnose case params.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot reset diagnose case params."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
